// One Stripe.js load per (publishable key + connected account) for the whole
// session — the connected account differs per TPS, so it's part of the cache
// key (loadStripe must not be called per render). Shared by every portal
// Stripe surface so they all hit the SAME cache. Track C: omit stripeAccount
// for a PLATFORM-scoped flow (the pre-loan buyer bank capture) — it gets its
// own cache slot so a platform load never reuses a connected-account instance.

import { loadStripe, type Stripe } from "@stripe/stripe-js";

const stripeLoaders = new Map<string, Promise<Stripe | null>>();

export function stripeFor(
  publishableKey: string,
  stripeAccount?: string,
): Promise<Stripe | null> {
  const cacheKey = `${publishableKey}:${stripeAccount ?? "__platform__"}`;
  let loader = stripeLoaders.get(cacheKey);
  if (!loader) {
    loader = stripeAccount
      ? loadStripe(publishableKey, { stripeAccount })
      : loadStripe(publishableKey);
    stripeLoaders.set(cacheKey, loader);
  }
  return loader;
}
